/**
 * Telepost Api
 * Для авторизации зайти http://local.telepost.me/  В `/etc/hosts` добавить запись  ```sh 127.0.0.1 local.telepost.me ``` При авторизации добавть `Bearer` перед токеном         
 *
 * OpenAPI spec version: 2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ChannelParticipantFull } from '../model/channelParticipantFull';
import { CreateAdminDto } from '../model/createAdminDto';
import { FindUserDto } from '../model/findUserDto';
import { UserShortInfoResponse } from '../model/userShortInfoResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChannelAdminsService {

    protected basePath = 'http://localhost/api';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Remove admin
     * 
     * @param adminId 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public _delete(adminId: string, channelId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public _delete(adminId: string, channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public _delete(adminId: string, channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public _delete(adminId: string, channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (adminId === null || adminId === undefined) {
            throw new Error('Required parameter adminId was null or undefined when calling _delete.');
        }

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling _delete.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/channel/${encodeURIComponent(String(channelId))}/admins/${encodeURIComponent(String(adminId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create channel admin
     * 
     * @param CreateAdminDto 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public add(CreateAdminDto: CreateAdminDto, channelId: string, observe?: 'body', reportProgress?: boolean): Observable<ChannelParticipantFull>;
    public add(CreateAdminDto: CreateAdminDto, channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChannelParticipantFull>>;
    public add(CreateAdminDto: CreateAdminDto, channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChannelParticipantFull>>;
    public add(CreateAdminDto: CreateAdminDto, channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (CreateAdminDto === null || CreateAdminDto === undefined) {
            throw new Error('Required parameter CreateAdminDto was null or undefined when calling add.');
        }

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling add.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ChannelParticipantFull>(`${this.basePath}/channel/${encodeURIComponent(String(channelId))}/admins`,
            CreateAdminDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete self from telepost editors
     * 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSelf(channelId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSelf(channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSelf(channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSelf(channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling deleteSelf.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/channel/${encodeURIComponent(String(channelId))}/editors`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user info by username
     * 
     * @param FindUserDto 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findUser(FindUserDto: FindUserDto, channelId: string, observe?: 'body', reportProgress?: boolean): Observable<UserShortInfoResponse>;
    public findUser(FindUserDto: FindUserDto, channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserShortInfoResponse>>;
    public findUser(FindUserDto: FindUserDto, channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserShortInfoResponse>>;
    public findUser(FindUserDto: FindUserDto, channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (FindUserDto === null || FindUserDto === undefined) {
            throw new Error('Required parameter FindUserDto was null or undefined when calling findUser.');
        }

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling findUser.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UserShortInfoResponse>(`${this.basePath}/channel/${encodeURIComponent(String(channelId))}/admins/find-user`,
            FindUserDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get channel admins
     * 
     * @param channelId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public list(channelId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ChannelParticipantFull>>;
    public list(channelId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ChannelParticipantFull>>>;
    public list(channelId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ChannelParticipantFull>>>;
    public list(channelId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (channelId === null || channelId === undefined) {
            throw new Error('Required parameter channelId was null or undefined when calling list.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<Array<ChannelParticipantFull>>(`${this.basePath}/channel/${encodeURIComponent(String(channelId))}/admins`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
